module.exports = __webpack_public_path__ + "static/img/brand7.1db735a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand7.png
// module id = 3Qf2
// module chunks = 1